import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/images/logo.png'


const _hoisted_1 = { class: "content-common-width" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "logo-wrapper" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "143",
  height: "39"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "language-wrapper" }

import { ref } from 'vue';
import { GlobalOutlined } from '@ant-design/icons-vue';
import { CookieStorage } from '@do/do-auth-web-client';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const { t, locale } = useI18n();
const officialUrl = ref(window.ENV_CONFIG.officialUrl);
const cookieStorage = new CookieStorage();
const selectedLanguage = ref(cookieStorage.getLocaleInfo() || 'zh');
const changeLanguage = (value: string) => {
    selectedLanguage.value = value;
    locale.value = value;
    cookieStorage.setLocaleInfo(value);
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              href: officialUrl.value,
              target: "_blank"
            }, _hoisted_6, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(GlobalOutlined)),
            _createVNode(_component_a_select, {
              value: selectedLanguage.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
              style: {"width":"100px"},
              onChange: changeLanguage,
              bordered: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "zh" }, {
                  default: _withCtx(() => [
                    _createTextVNode("简体中文")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "en" }, {
                  default: _withCtx(() => [
                    _createTextVNode("English")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_RouterView)
    ])
  ], 64))
}
}

})